module.exports = __webpack_public_path__ + "img/9791157400850.db2f5841.jpg";